import { albumPhotoBackground } from "../../lib/albumsUtils";

/**
 * @param {{ album: import("../../data/albums").Album, onOpen: (id: string) => void }} props
 */
export default function AlbumCard({ album, onOpen }) {
  return (
    <button
      type="button"
      className="album-card"
      style={{ background: albumPhotoBackground(album.cover) }}
      onClick={() => onOpen(album.id)}
    >
      <div className="album-card__scrim" />
      <span className="album-card__count">{album.count} PHOTOS</span>
      <div className="album-card__body">
        <div className="album-card__title">{album.title}</div>
        <div className="album-card__subtitle">{album.subtitle}</div>
        <div className="album-card__cta">
          OPEN ALBUM <span aria-hidden="true">→</span>
        </div>
      </div>
    </button>
  );
}
